import { __ } from '../../../locales'

function camelCaseToWords(s) {
    if (!s) {
        return undefined
    }
    return s.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
}

const ThemeFilter = ({ inputs, changeTheme, themeList }) => {
    return (
        <div className={'input-component'}>
            <label>{__('inputs.select_theme.label')}: </label>
            <select className="form-control" value={inputs.theme} onInput={(ev => {
                changeTheme(ev.target.value);
            })}>
                {themeList.map(theme => (
                    <option label={__(`theme.${camelCaseToWords(theme)}`)} value={theme}>{theme}</option>
                ))}
            </select>
        </div>
    );
};

export default ThemeFilter;
